import { Component, Fragment } from "react";
import { ReactTitle } from "react-meta-tags";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import LoaderNews from "../../components/Loader/LoaderNews";
import ItemNews from "../../components/News/ShortNews";
import Pagination from "../../components/Pagination/Pagination";
import { fetchNews } from "../../store/actions/news";
import { getActivePage, getTag } from "../../utils/utils";

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: getActivePage(this.props.location.search),
      activeTag: getTag(this.props.location.search),
    };
  }

  componentDidMount = () => {
    this.props.fetchNews(
      getActivePage(this.props.location.search),
      getTag(this.props.location.search)
    );
  };

  componentDidUpdate = () => {
    if (
      this.state.activePage !== getActivePage(this.props.location.search) ||
      this.state.activeTag !== getTag(this.props.location.search)
    ) {
      this.setState({
        activePage: getActivePage(this.props.location.search),
        activeTag: getTag(this.props.location.search),
      });
      this.props.fetchNews(
        getActivePage(this.props.location.search),
        getTag(this.props.location.search)
      );
    }
  };
  render() {
    return (
      <Fragment>
        <ReactTitle title="Новости" />

        <br />
        <ul className="breadcrumb">
          <li>
            <Link to="/">Главная</Link>
          </li>
          <li className="active">Новости</li>
        </ul>
        <h1>Новости</h1>
        <br />
        <div className="Chronology-container">
          <div className="pages-wrap">
            <div className="sidebar">
              <Link className="btn btn-primary" to="/news">
                Новости фонда
              </Link>
              <Link className="btn btn-primary" to="?tag=Юристы+разъясняют">
                Юристы разъясняют
              </Link>
              <Link className="btn btn-primary" to="?tag=Полезно+знать">
                Полезно знать
              </Link>
            </div>
            <div className="pages-content">
              <div className="Chronology-wrapper">
                {this.props.loadingNews && this.props.news.length === 0 ? (
                  <LoaderNews count={10} />
                ) : (
                  <>
                    {this.props.news.map((item) => {
                      return <ItemNews key={item.id} item={item} />;
                    })}
                  </>
                )}
              </div>
            </div>
            {this.props.countPages > 1 && (
              <Pagination
                activePage={this.props.activePage}
                pageCounts={this.props.countPages}
                tag={getTag(this.props.location.search)}
              />
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    news: state.news.news || [],
    loadingNews: state.news.loading,
    activePage: state.news.activePage,
    countPages: state.news.countPages,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchNews: (page, tag) => dispatch(fetchNews(page, 10, tag)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(News);
